import { PlatformLogo } from "@/components/platform";

import { PlatformSearchItem } from "../GlobalSearch.types";
import { GlobalSearchItemTypeChip } from "../GlobalSearchItemTypeChip";
import { SearchItemLabel } from "../SearchItemLabel";

export type PlatformSearchItemViewProps = {
  item: PlatformSearchItem;
};

export const PlatformSearchItemView = ({ item }: PlatformSearchItemViewProps) => {
  return (
    <div className="flex items-center justify-between w-full gap-2">
      <div className="flex items-center gap-4 flex-2 min-w-0">
        <PlatformLogo platform={item.platform} height={30} width={30} />
        <div className="flex flex-col min-w-0 flex-1">
          <SearchItemLabel>{item.platform.title}</SearchItemLabel>
        </div>
      </div>
      <div className="flex items-center shrink-0">
        <GlobalSearchItemTypeChip type="platform" />
      </div>
    </div>
  );
};
